import { render } from "./ShippingTypeMultiSelect.vue?vue&type=template&id=75771386&ts=true"
import script from "./ShippingTypeMultiSelect.vue?vue&type=script&lang=ts"
export * from "./ShippingTypeMultiSelect.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__